<div class="col-xs-12 col-sm-3" style="margin-left: 25%">
    <highcharts-chart [options]="finChart"></highcharts-chart>
</div>